<div >
  <mat-select [(ngModel)]="valueSelected" #container>
    @for (value of values; track value) {
      <mat-option [value]="value.id"> {{ value.name || value.name_ar }}</mat-option>
    }
  </mat-select>
</div>
